import { useMutation } from 'react-query';
import {
  createGeneralRecognitionAsync,
  createGeneralRecognitionAsyncJob,
  deleteGeneralRecognitionAsyncJob,
  getGeneralRecognitionByIdAsync,
  updateGeneralRecognitionAsync,
  updateGeneralRecognitionAsyncJob,
} from '../../index';

export const useCreateGeneralRecognitionAsync = () =>
  useMutation(createGeneralRecognitionAsync);

export const useCreateGeneralRecognitionAsyncJob = () =>
  useMutation(createGeneralRecognitionAsyncJob);

export const useUpdateGeneralRecognitionAsync = () =>
  useMutation(updateGeneralRecognitionAsync);

export const useUpdateGeneralRecognitionAsyncJob = () =>
  useMutation(updateGeneralRecognitionAsyncJob);

export const useDeleteGeneralRecognitionAsyncJob = () =>
  useMutation(deleteGeneralRecognitionAsyncJob);

export const useGetGeneralRecognitionByIdAsync = () =>
  useMutation(getGeneralRecognitionByIdAsync);
